// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3098748c","455":"ecd36b40","977":"bc72b354"}[chunkId] + ".chunk.js";
};